"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressChangePriceOutputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var PremiumOutputWidget_1 = require("../subscription/PremiumOutputWidget");
var commonFunctions_1 = require("../../commonFunctions");
var IPTDisclamer_1 = require("../../components/IPTDisclamer");
var components_1 = require("@athena-portal/components");
var AddressChangePriceOutputWidget = /** @class */ (function (_super) {
    __extends(AddressChangePriceOutputWidget, _super);
    function AddressChangePriceOutputWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.amountToDisplay = function () {
            var neverHigherAmount = (0, commonFunctions_1.getNeverHigherPeriodAmount)(_this.props.interaction);
            var neverHigherAmountWording = (0, commonFunctions_1.getNeverHigherPeriodWording)(_this.props.interaction, neverHigherAmount, _this.state.policies);
            var priceExplanationSection = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { className: "mb-0", children: "to change your address." }), (0, jsx_runtime_1.jsx)("p", { className: "text-center mx-4 mb-0", children: "Your price could go up or down, but we guarantee you won't pay more than" }), (0, jsx_runtime_1.jsx)("p", { className: "text-center font-weight-bold mx-4", children: neverHigherAmountWording })] });
            var _a = _this.props.interaction.factors, returnPremium = _a.returnPremium, additionalPremium = _a.additionalPremium;
            var displayMessage;
            if (additionalPremium && additionalPremium > 0) {
                window.sessionStorage.setItem("additionalPremium", additionalPremium);
                displayMessage = (0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { id: "price", className: "price-address-change", children: (0, commonFunctions_1.getAmountToDisplay)(additionalPremium) }), priceExplanationSection, (0, jsx_runtime_1.jsx)(IPTDisclamer_1.default, { cssClass: "text-center mx-4 mb-0" })] });
            }
            else if (returnPremium && returnPremium > 0) {
                window.sessionStorage.setItem("returnPremium", returnPremium);
                displayMessage = (0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold", children: "Refund of" }), (0, jsx_runtime_1.jsx)("p", { id: "price", className: "price-address-change", children: (0, commonFunctions_1.getAmountToDisplay)(returnPremium) }), priceExplanationSection, (0, jsx_runtime_1.jsx)(IPTDisclamer_1.default, { cssClass: "text-center mx-4 mb-0" })] });
            }
            else {
                displayMessage = (0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold", children: "There is no extra cost" }), priceExplanationSection, (0, jsx_runtime_1.jsx)(IPTDisclamer_1.default, { cssClass: "text-center mx-4 mb-0" })] });
            }
            return displayMessage;
        };
        return _this;
    }
    AddressChangePriceOutputWidget.prototype.render = function () {
        if (this.state.subscription && this.state.policies) {
            return ((0, jsx_runtime_1.jsx)("div", { className: "panel text-center", children: this.amountToDisplay() }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
    };
    return AddressChangePriceOutputWidget;
}(PremiumOutputWidget_1.PremiumOutputWidget));
exports.AddressChangePriceOutputWidget = AddressChangePriceOutputWidget;
//# sourceMappingURL=AddressChangePriceOutputWidget.js.map